import { alpha, IconButton, useTheme } from "@mui/material";

export default function HeaderIconButton({ testId, children, ...props }) {
  const theme = useTheme();

  return (
    <IconButton
      data-testid={testId}
      sx={{
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          transform: "scale(1.05)",
        },
      }}
      {...props}
    >
      {children}
    </IconButton>
  );
}
